<template>
  <Modal
    v-model="_value"
    width="900"
    title="查看/修改第三方监控订单"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
          <Form :model="monitoringserviceOrder" :rules="rules" :label-width="90">
            <Row>
              <Col span="8">
                <FormItem prop="registrationNum" label="车牌号码">
                  <Input :disabled="!modify" class="field" v-model="monitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationNum" placeholder="请输入车牌号码">
                  </Input>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="name" label="车牌颜色">
                  <Select :disabled="!modify" class="field" v-model="monitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationColor">
                    <Option v-for="item in registrationColorOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="vin" label="车架号">
                  <Input :disabled="!modify" class="field" v-model="monitoringserviceOrder.monitoringServiceTempVehicleInfo.vin" placeholder="请输入车架号">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="totalAmount" label="应收总金额">
                  <InputNumber :disabled="!modify" :min="0" class="field" v-model="monitoringserviceOrder.totalAmount" placeholder="请输入应收总金额"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="serviceDatetime" label="服务到期时间">
                  <DatePicker :disabled="!modify" type="date" v-model="monitoringserviceOrder.serviceDatetime"
                              placeholder="选择日期"></DatePicker>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="serviceDatetime" label="订单类型">
                  <Select :disabled="!modify" class="field" v-model="monitoringserviceOrder.monitoringServicePackage">
                    <Option v-for="item in monitoringServicePackageOptions" :value="item.value" :key="item.value">
                      {{item.label}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="businessUserId" label="跟进业务员">
                  <Select :disabled="!modify" class="field" v-model="monitoringserviceOrder.businessUserId">
                    <Option v-for="item in businessUsers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="billType" label="开票类型">
                  <Select :disabled="!modify" class="field" v-model="monitoringserviceOrder.billType">
                    <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="8">
                <FormItem prop="businessUserId" label="是否已收款">
                  <RadioGroup v-model="monitoringserviceOrder.receptDatetime">
                    <Radio label="是"></Radio>
                    <Radio label="否"></Radio>
                  </RadioGroup>
                </FormItem>
              </Col>
              <Col span="8">
                <FormItem prop="qghyptOption" label="是否加急">
                  <Space direction="vertical" size="large">
                    <RadioGroup v-model="monitoringserviceOrder.urgent">
                      <Radio label="是"></Radio>
                      <Radio label="否"></Radio>
                    </RadioGroup>
                  </Space>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem prop="clientInfoId" label="客户信息">
                  <Select :disabled="!modify"
                          placeholder="请选择客户名称"
                          v-model="monitoringserviceOrder.clientInfoId"
                          filterable
                          remote
                          :remote-method="searchClientInfoValue"
                          :loading="searchClientInfoLoading"
                          class="field" style="width: 60%;"
                          clearable>
                    <Option v-for="(option, index) in searchClientInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="addClientInfoModal=true">添加客户信息</Button>
                </FormItem>
              </Col>
              <Col span="12">
                <FormItem prop="vehicleOwnerInfoId" label="车辆所有人信息">
                  <Select :disabled="!modify"
                          placeholder="请选择车辆所有人名称"
                          v-model="monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId"
                          filterable
                          remote
                          :remote-method="searchVehicleOwnerInfo"
                          :loading="searchVehicleOwnerInfoLoading"
                          class="field" style="width: 60%;"
                          clearable>
                    <Option v-for="(option, index) in searchVehicleOwnerInfoList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddVehicleOwnerInfoBtn">添加所有人</Button>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="12">
                <FormItem prop="vehicleInfoGroupId" label="预绑定车辆分组">
                  <Select :disabled="!modify"
                          placeholder="请选择车辆分组名称"
                          v-model="monitoringserviceOrder.vehicleInfoGroupId"
                          filterable
                          remote
                          :remote-method="searchVehicleInfoGroup"
                          :loading="searchVehicleInfoGroupLoading"
                          class="field" style="width: 60%;"
                          clearable>
                    <Option v-for="(option, index) in searchVehicleInfoGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
                  </Select>
                  <Button type="primary" style="margin-left: 5px;" @click="onAddClientInfoGroupBtn">添加车辆分组</Button>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="orderRemark" label="订单备注">
                  <Input :disabled="!modify" class="field" style="width: 80%;" v-model="monitoringserviceOrder.remark" type="textarea">
                  </Input>
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="24">
                <FormItem prop="history" label="历史记录">
                  <Input :disabled="true" class="field" style="width: 80%;" v-model="monitoringserviceOrder.history" type="textarea" :rows="5">
                  </Input>
                </FormItem>
              </Col>
            </Row>
          </Form>
      <Row style="text-align: right;">
        <!--<Button v-if="monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificatePictureId" type="default" @click="onAnalyzeCertificatePicture" style="margin-right: 5px;">识别车辆合格证</Button>-->
        <i-switch v-model="modify" @on-change="modifyChange" size="large">
          <span slot="open">保存</span>
          <span slot="close">修改</span>
        </i-switch>
      </Row>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="dataLoading">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <add-client-info-modal v-model="addClientInfoModal" @on-success="onSuccess"></add-client-info-modal>
    <add-vehicle-info-group-noparent-modal v-model="addVehicleInfoGroupNoparentModal" :parentGroupId="addVehicleInfoGroupParentId"></add-vehicle-info-group-noparent-modal>
    <add-vehicle-owner-info-modal v-model="addVehicleOwnerInfoModal" @on-success="onSuccess"></add-vehicle-owner-info-modal>
  </Modal>
</template>
<script>

import AddClientInfoModal from '@/view/crm/components/add-client-info-modal'
import AddVehicleInfoGroupNoparentModal from '@/view/crm/components/add-vehicle-info-group-noparent-modal'
import AddVehicleOwnerInfoModal from '@/view/crm/components/add-vehicle-owner-info-modal'

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'monitoringserviceorderdetailmodal',
  components: {
    AddClientInfoModal,
    AddVehicleInfoGroupNoparentModal,
    AddVehicleOwnerInfoModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    nameRules: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '车辆名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {

      dataLoading: false,

      modify: false,

      analyzing: false,

      // 添加车辆所有人
      addVehicleOwnerInfoModal: false,

      // 添加客户信息
      addClientInfoModal: false,

      // 添加车辆分组
      addVehicleInfoGroupNoparentModal: false,
      addVehicleInfoGroupParentId: null,

      searchSalesChannelValue: null,
      searchSalesChannelLoading: false,
      searchSalesChannelList: [],

      searchVehicleInfoGroupValue: null,
      searchVehicleInfoGroupLoading: false,
      searchVehicleInfoGroupList: [],

      initVehicleModel: null,
      searchVehicleModelLoading: false,
      searchVehicleModelList: [],
      initClientInfo: null,
      searchClientInfoLoading: false,
      searchClientInfoList: [],
      searchClientInfoValue: null,
      initVehicleOwnerInfo: null,
      searchVehicleOwnerInfoValue: null,
      searchVehicleOwnerInfoLoading: false,
      searchVehicleOwnerInfoList: [],
      initVehicleType: null,
      searchVehicleTypeLoading: false,
      searchVehicleTypeList: [],
      initVehicleBrand: null,
      searchVehicleBrandLoading: false,
      searchVehicleBrandList: [],

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ],

      qghyptOptions: [
        { label: '不需上传', value: 0 },
        { label: '新车上传', value: 1 },
        { label: '旧车转网', value: 2 }
      ],

      monitoringserviceOrderBusinessType: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 },
        { label: '在网升级', value: 3 }
      ],

      registrationColorOptions: [
        { label: '蓝色', value: 1 },
        { label: '黄色', value: 2 },
        { label: '黑色', value: 3 },
        { label: '白色', value: 4 },
        { label: '渐变绿色', value: 5 },
        { label: '黄绿色', value: 6 },
      ],

      // 第三方监控订单类型
      monitoringServicePackageOptions: [
        { label: '基础版', value: 1 },
        { label: '标准版', value: 2 },
        { label: '专业版', value: 3 }
      ],

      businessUsers: [],

      monitoringserviceOrder: {
        id: null,
        totalAmount: null,
        serviceDatetime: null,
        businessUserId: null,
        businessType: null,
        multiDevices: false,
        qghyptOption: 0,
        clientInfoId: null,
        history: null,
        remark: null,
        monitoringServicePackage: 1,
        billType: 1,
        isfree: null,
        vehicleInfoGroupId: null,
        monitoringServiceTempVehicleInfo: {
          customName: null,
          registrationNum: null,
          registrationColor: null,
          vin: null,
          bodyColor: null,
          vehicleType: {
            name: null
          },
          vehicleBrand: {
            name: null
          },
          engineNum: null,
          vehicleLicenseNum: null,
          unladenMass: null,
          approvedLoad: null,
          vehicleOwnerInfoId: null,
          servicePassword: null,
          vehicleLicenseDistributeDatetime: null,
          vehicleLicenseReigsterDatetime: null,
          remark: null,
          identificationCode: null,
          certificateNum: null,
          certificateDistributeDatetime: null,
          vehicleModel: {
            name: null
          },
          chassisModel: null,
          chassisId: null,
          chassisCertificateNum: null,
          engineModel: null,
          energyType: null,
          displacement: null,
          power: null,
          energyUsage: null,
          emissionStandard: null,
          manufacturer: null,
          outlineSizeLong: null,
          outlineSizeWidth: null,
          outlineSizeHeight: null,
          boxSizeLong: null,
          boxSizeWidth: null,
          boxSizeHeight: null,
          springPieceCount: null,
          tyreCount: null,
          tyreSpec: null,
          wheelSpanFront: null,
          wheelSpanBack: null,
          wheelBase: null,
          axisLoad: null,
          axisCount: null,
          turnType: null,
          totalMass: null,
          approvedLoadCoefficient: null,
          towMax: null,
          saddleMax: null,
          cabPeopleCount: null,
          mannedCount: null,
          speedMax: null,
          productionDatetime: null,
          certificateRemark: null,
          vehicleLicensePictureId: null,
          certificatePictureId: null,
          vehicleSrcLicensePicture1Id: null,
          vehicleSrcLicensePicture2Id: null,
          vehicleBodyPictureId: null,
          vehicleUse: null,
          attention: false,
          mliftainsuranceChannelId: null,
          mliftainsurancechannelDatetime: null,
          tiinsuranceChannelId: null,
          tiinsurancechannelDatetime: null,
          insured: null
        },
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        },
        salesChannelId: null
      }
    }
  },
  methods: {
    ...mapActions([
      'MonitoringServiceOrderServ_GetDetail',
      'MonitoringServiceOrderServ_ModifyObj',
      'VehicleInfoServ_AnalyzeCertificatePicture',
      'VehicleInfoServ_AnalyzeVehicleLicensePicture'
    ]),
    // onAnalyzeCertificatePicture(){
    //   console.log('onAnalyzeCertificatePicture')
    //   store.dispatch('VehicleInfoServ_AnalyzeCertificatePicture', {
    //     params: {id: this._initValue},
    //     urlparams: null
    //   }).then(() => {
    //     this.$Message.success('分析完成')
    //     let vehicleInfoId = this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.id
    //     store.dispatch('VehicleInfoServ_GetDetail', {
    //       params: {id: vehicleInfoId}
    //     }).then(() => {
    //       this.updateInfo(store.getters.get_VehicleInfo_GetDetailResult)
    //     }).catch(err => {
    //       this.$Message.error(err)
    //     })
    //   }).catch(err => {
    //     this.$Message.error(err)
    //   })
    // },
    onAddVehicleOwnerInfoBtn () {
      this.addVehicleOwnerInfoModal = true
    },
    onAddClientInfoGroupBtn () {
      this.addVehicleInfoGroupNoparentModal = true
    },
    onSuccess () {

    },
    searchVehicleType (input) {
      this.searchVehicleTypeLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleTypeList = []
        this.searchVehicleTypeLoading = false
      } else {
        store.dispatch('VehicleTypeServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleTypeList = store.getters.get_VehicleType_SearchByNameResult ? store.getters.get_VehicleType_SearchByNameResult : []
          this.searchVehicleTypeLoading = false
        }).catch(err => {
          this.searchVehicleTypeLoading = false
        })
      }
    },
    searchVehicleBrand (input) {
      this.searchVehicleBrandLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleBrandList = []
        this.searchVehicleBrandLoading = false
      } else {
        store.dispatch('VehicleBrandServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleBrandList = store.getters.get_VehicleBrand_SearchByNameResult ? store.getters.get_VehicleBrand_SearchByNameResult : []
          this.searchVehicleBrandLoading = false
        }).catch(err => {
          this.searchVehicleBrandLoading = false
        })
      }
    },
    searchVehicleOwnerInfo (input) {
      console.log(input)
      this.searchVehicleOwnerInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleOwnerInfoList = []
        this.searchVehicleOwnerInfoLoading = false
      } else {
        store.dispatch('VehicleOwnerInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleOwnerInfoList = store.getters.get_VehicleOwnerInfo_SearchByNameResult ? store.getters.get_VehicleOwnerInfo_SearchByNameResult : []
          this.searchVehicleOwnerInfoLoading = false
        }).catch(err => {
          this.searchVehicleOwnerInfoLoading = false
        })
      }
    },
    searchClientInfo (input) {
      console.log(input)
      console.log('searchClientInfo')
      this.searchClientInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchClientInfoList = []
        this.searchClientInfoLoading = false
      } else {
        store.dispatch('ClientInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchClientInfoList = store.getters.get_ClientInfo_SearchByNameResult ? store.getters.get_ClientInfo_SearchByNameResult : []
          this.searchClientInfoLoading = false
        }).catch(err => {
          this.searchClientInfoLoading = false
        })
      }
    },
    searchVehicleInfoGroup (input) {
      this.searchVehicleInfoGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleInfoGroupList = []
        this.searchVehicleInfoGroupLoading = false
      } else {
        store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleInfoGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
          this.searchVehicleInfoGroupLoading = false
        }).catch(err => {
          this.searchVehicleInfoGroupLoading = false
        })
      }
    },
    searchVehicleModel (input) {
      this.searchVehicleModelLoading = true
      if (!input || input.length <= 0) {
        this.searchVehicleModelList = []
        this.searchVehicleModelLoading = false
      } else {
        store.dispatch('VehicleModelServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchVehicleModelList = store.getters.get_VehicleModel_SearchByNameResult ? store.getters.get_VehicleModel_SearchByNameResult : []
          this.searchVehicleModelLoading = false
        }).catch(err => {
          this.searchVehicleModelLoading = false
        })
      }
    },
    modifyChange (status) {
      if (status === false) {
        if (this.monitoringserviceOrder.receptDatetime === '是') {
          this.monitoringserviceOrder.receptDatetime = new Date()
        } else {
          this.monitoringserviceOrder.receptDatetime = null
        }
        if (this.monitoringserviceOrder.urgent === '是') {
          this.monitoringserviceOrder.urgent = true
        } else {
          this.monitoringserviceOrder.urgent = false
        }
        this.$Modal.confirm({
          title: '确认修改第三方监控订单',
          content: '<p>确认修改第三方监控订单</p>',
          onOk: () => {
            store.dispatch('MonitoringServiceOrderServ_ModifyObj', { params: this.monitoringserviceOrder }).then(() => {
              this.$Message.success('确认修改第三方监控订单')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
              let monitoringserviceOrderId = this._initValue
              store.dispatch('MonitoringServiceOrderServ_GetDetail', {
                params: { id: monitoringserviceOrderId }
              }).then(() => {
                this.updateInfo(store.getters.get_MonitoringServiceOrder_GetDetailResult)
              }).catch(err => {
                this.$Message.error(err)
              })
            })
          },
          onCancel: () => {
            let monitoringserviceOrderId = this._initValue
            store.dispatch('MonitoringServiceOrderServ_GetDetail', {
              params: { id: monitoringserviceOrderId }
            }).then(() => {
              this.updateInfo(store.getters.get_MonitoringServiceOrder_GetDetailResult)
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        })
      }
    },
    visibleChange (val) {
      if (val) {
        this.dataLoading = true
        this.modify = false
        this.cleanData()
        let monitoringserviceOrderId = this._initValue
        if (monitoringserviceOrderId) {
          store.dispatch('MonitoringServiceOrderServ_GetDetail', {
            params: { id: monitoringserviceOrderId }
          }).then(() => {
            this.updateInfo(store.getters.get_MonitoringServiceOrder_GetDetailResult)
            this.dataLoading = false
          }).catch(err => {
            this.$Message.error(err)
            this.dataLoading = false
          })
        }

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          this.businessUsers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    cleanData () {
      this.monitoringserviceOrder.id = null
      this.monitoringserviceOrder.totalAmount = null
      this.monitoringserviceOrder.serviceDatetime = null
      this.monitoringserviceOrder.businessUserId = null
      this.monitoringserviceOrder.businessType = null
      this.monitoringserviceOrder.multiDevices = false
      this.monitoringserviceOrder.qghyptOption = 0
      this.monitoringserviceOrder.history = null
      this.monitoringserviceOrder.remark = null
      this.monitoringserviceOrder.monitoringServicePackage = 1
      this.monitoringserviceOrder.clientInfoId = null
      this.monitoringserviceOrder.vehicleInfoGroupId = null
      this.monitoringserviceOrder.billType = 1
      this.monitoringserviceOrder.salesChannelId = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.customName = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationNum = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationColor = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vin = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.bodyColor = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleType.name = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBrand.name = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.engineNum = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseNum = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.unladenMass = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.approvedLoad = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.clientInfoId = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.servicePassword = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseDistributeDatetime = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseReigsterDatetime = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.remark = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateNum = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateDistributeDatetime = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleModel.name = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisModel = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisId = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisCertificateNum = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.engineModel = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.energyType = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.displacement = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.power = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.energyUsage = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.emissionStandard = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.manufacturer = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeLong = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeWidth = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeHeight = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeLong = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeWidth = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeHeight = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.springPieceCount = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.tyreCount = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.tyreSpec = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelSpanFront = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelSpanBack = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelBase = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.axisLoad = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.axisCount = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.turnType = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.totalMass = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.approvedLoadCoefficient = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.towMax = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.saddleMax = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.cabPeopleCount = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.mannedCount = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.speedMax = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.productionDatetime = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateRemark = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicensePictureId = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificatePictureId = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture1Id = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture2Id = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBodyPictureId = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.test = false
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleUse = null
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.attention = false
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.identificationCode = null
    },
    updateInfo (existMonitoringserviceOrder) {
      this.monitoringserviceOrder.id = existMonitoringserviceOrder.id
      this.monitoringserviceOrder.totalAmount = existMonitoringserviceOrder.totalAmount
      this.monitoringserviceOrder.serviceDatetime = existMonitoringserviceOrder.serviceDatetime === null ? null : new Date(existMonitoringserviceOrder.serviceDatetime)
      this.monitoringserviceOrder.businessUserId = existMonitoringserviceOrder.businessUserId
      this.monitoringserviceOrder.businessType = existMonitoringserviceOrder.businessType
      this.monitoringserviceOrder.multiDevices = existMonitoringserviceOrder.multiDevices
      this.monitoringserviceOrder.qghyptOption = existMonitoringserviceOrder.qghyptOption
      this.monitoringserviceOrder.history = existMonitoringserviceOrder.history
      this.monitoringserviceOrder.remark = existMonitoringserviceOrder.remark
      this.monitoringserviceOrder.monitoringServicePackage = existMonitoringserviceOrder.monitoringServicePackage
      this.monitoringserviceOrder.billType = existMonitoringserviceOrder.billType
      this.monitoringserviceOrder.salesChannelId = existMonitoringserviceOrder.salesChannelId
      this.monitoringserviceOrder.isfree = existMonitoringserviceOrder.isfree
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.id = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.id
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.customName = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.customName
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationNum = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationNum
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationColor = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.registrationColor
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vin = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vin
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.bodyColor = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.bodyColor
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleType.name = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleType === null ? null : existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleType.name
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBrand.name = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBrand === null ? null : existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBrand.name
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.engineNum = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.engineNum
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseNum = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseNum
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.unladenMass = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.unladenMass
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.approvedLoad = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.approvedLoad
      // this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.servicePassword = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.servicePassword
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseDistributeDatetime = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseDistributeDatetime === null ? null : new Date(existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseDistributeDatetime)
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseReigsterDatetime = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseReigsterDatetime === null ? null : new Date(existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicenseReigsterDatetime)
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.remark = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.remark
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateNum = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateNum
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateDistributeDatetime = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateDistributeDatetime === null ? null : new Date(existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateDistributeDatetime)
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleModel.name = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleModel === null ? null : existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleModel.name
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisModel = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisModel
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisId
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisCertificateNum = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.chassisCertificateNum
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.engineModel = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.engineModel
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.energyType = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.energyType
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.displacement = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.displacement
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.power = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.power
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.energyUsage = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.energyUsage
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.emissionStandard = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.emissionStandard
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.manufacturer = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.manufacturer
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeLong = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeLong
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeWidth = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeWidth
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeHeight = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.outlineSizeHeight
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeLong = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeLong
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeWidth = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeWidth
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeHeight = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.boxSizeHeight
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.springPieceCount = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.springPieceCount
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.tyreCount = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.tyreCount
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.tyreSpec = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.tyreSpec
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelSpanFront = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelSpanFront
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelSpanBack = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelSpanBack
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelBase = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.wheelBase
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.axisLoad = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.axisLoad
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.axisCount = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.axisCount
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.axisCount = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.axisCount
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.totalMass = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.totalMass
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.approvedLoadCoefficient = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.approvedLoadCoefficient
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.towMax = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.towMax
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.saddleMax = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.saddleMax
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.cabPeopleCount = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.cabPeopleCount
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.mannedCount = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.mannedCount
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.speedMax = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.speedMax
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.productionDatetime = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.productionDatetime === null ? null : new Date(existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.productionDatetime)
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateRemark = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.certificateRemark
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicensePictureId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleLicensePictureId
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.certificatePictureId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.certificatePictureId
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture1Id = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture1Id
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture2Id = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleSrcLicensePicture2Id
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBodyPictureId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBodyPictureId
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleUse = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleUse
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.attention = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.attention
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.identificationCode = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.identificationCode
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.mliftainsuranceChannelId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.mliftainsuranceChannelId
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.mliftainsurancechannelDatetime = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.mliftainsurancechannelDatetime === null ? null : new Date(existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.mliftainsurancechannelDatetime)
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.tiinsuranceChannelId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.tiinsuranceChannelId
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.tiinsurancechannelDatetime = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.tiinsurancechannelDatetime === null ? null : new Date(existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.tiinsurancechannelDatetime)
      this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.insured = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.insured

      if (existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId) {
        this.searchVehicleOwnerInfoList = []
        existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfo.name = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfo.name + '(' + existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfo.address + ')'
        this.searchVehicleOwnerInfoList.push(existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfo)
        this.searchVehicleOwnerInfoValue = this.searchVehicleOwnerInfo
        console.log(this.searchVehicleOwnerInfoList)
      }

      if (existMonitoringserviceOrder.clientInfoId) {
        this.searchClientInfoList = []
        existMonitoringserviceOrder.clientInfo.name = existMonitoringserviceOrder.clientInfo.name + '(' + existMonitoringserviceOrder.clientInfo.phoneNum + ')'
        this.searchClientInfoList.push(existMonitoringserviceOrder.clientInfo)
        this.searchClientInfoValue = this.searchClientInfo
      }

      if (existMonitoringserviceOrder.vehicleInfoGroupId) {
        this.searchVehicleInfoGroupList = []
        // existMonitoringserviceOrder.vehicleInfoGroup.name = existMonitoringserviceOrder.clientInfo.name + '(' + existMonitoringserviceOrder.clientInfo.phoneNum + ')'
        this.searchVehicleInfoGroupList.push(existMonitoringserviceOrder.vehicleInfoGroup)
        this.searchVehicleInfoGroupValue = this.searchVehicleInfoGroup
      }

      if (existMonitoringserviceOrder.salesChannelId) {
        this.searchSalesChannelList = []
        // existMonitoringserviceOrder.vehicleInfoGroup.name = existMonitoringserviceOrder.clientInfo.name + '(' + existMonitoringserviceOrder.clientInfo.phoneNum + ')'
        this.searchSalesChannelList.push(existMonitoringserviceOrder.salesChannel)
        this.searchSalesChannelValue = this.searchSalesChannel
      }

      if (existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleModel) {
        this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleModel.name = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleModel.name
      }

      if (existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleType) {
        this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleType.name = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleType.name
      }

      if (existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBrand) {
        this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBrand.name = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleBrand.name
      }

      store.dispatch('MonitoringServiceOrderServ_GetDetail', {
        params: { id: this._initValue }
      }).then(() => {
        this.monitoringserviceOrder.clientInfoId = existMonitoringserviceOrder.clientInfoId
        this.monitoringserviceOrder.salesChannelId = existMonitoringserviceOrder.salesChannelId
        this.monitoringserviceOrder.vehicleInfoGroupId = existMonitoringserviceOrder.vehicleInfoGroupId
        this.monitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId = existMonitoringserviceOrder.monitoringServiceTempVehicleInfo.vehicleOwnerInfoId
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.nameRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

  .field {
    margin-left: 5px;
    width: 70%;
  }
</style>
